import { TabItemProps } from './TabItem';
import { Theme, css } from '@emotion/react';

export const tabItemBase = (
  { spacing, colors, shape }: Theme,
  isSelected: TabItemProps<'button'>['isSelected']
) => css`
  padding: ${spacing(1)}px 0;
  position: relative;
  display: flex;
  justify-content: center;
  gap: ${spacing(1)}px;
  align-items: center;
  min-height: ${spacing(6)}px;
  text-decoration: none;

  &:hover {
    &::after {
      content: '';
      border-bottom: 3px solid ${colors.borderDefault};
      width: 100%;
      bottom: 0;
      display: block;
      position: absolute;
    }
  }

  ${isSelected &&
  `
	color: ${colors.fgPrimaryBase};
	&::after {
	  content: '';
	  border-bottom: 3px solid ${colors.fgPrimaryBase};
	  width: 100%;
	  bottom: 0;
	  display: block;
	  position: absolute;
	}

	&:hover {
		&::after {
			content: '';
			border-bottom: 3px solid ${colors.fgPrimaryBase};
			width: 100%;
			bottom: 0;
			display: block;
			position: absolute;
		}
	  }
	`}
`;

export const tabItemLabel = (
  { colors }: Theme,
  isSelected: TabItemProps<'button'>['isSelected']
) => css`
  ${isSelected &&
  `
	color: ${colors.fgPrimaryBase};
	`}
`;
